import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHighestPrice = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_497_92",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			className: "custom-rect",
			width: 20,
			height: 20,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_497_92)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.45842 15.5834V6.49841L5.19071 10.7661L4.41675 10.0001L10.0001 4.41675L15.5834 10.0001L14.8095 10.7661L10.5417 6.49841V15.5834H9.45842Z",
			fill: "currentColor"
		})
	})]
});
export default SvgHighestPrice;
